module.exports = __webpack_public_path__ + "img/second-4.6bca895c.webp";